import ArrowRightSVG from "../../../../svgs/ArrowRightSVG";
import { useState } from "react";
import Description from "./CivilLaw/Description";
import GreatSVG from "../../../../svgs/GreatSVG";
import GoodSVG from "../../../../svgs/GoodSVG";
import BadSVG from "../../../../svgs/BadSVG";
import VeryBadSVG from "../../../../svgs/VeryBadSVG";

const Content = () => {
  const [MainPage, setMainPage] = useState("Civil law");
  const [MainTitle, setMainTitle] = useState("Description");
  return (
    <div className="flex flex-col w-[55%] pb-20">
      <div className="flex items-center gap-3 text-[14px]">
        <span className="text-subColor3">{MainPage} </span>
        <ArrowRightSVG height={12} width={12} className="scale-110" />
        <span className="text-white">{MainTitle} </span>
      </div>
      {MainPage === "Civil law" && (
        <>
          {MainTitle === "Description" && <Description />}
          {MainTitle === "Problems" && <Description />}
        </>
      )}
      <div className="w-[273px] h-12 mx-auto mt-20 flex items-center justify-between bg-[#0A0A0A] rounded-full border border-[#333] text-subColor3 text-[14px] p-3">
        <span>Was this helpful?</span>
        <div className="flex items-center gap-[14px] [&>svg]:cursor-pointer">
            <GreatSVG />
            <GoodSVG />
            <BadSVG />
            <VeryBadSVG />
        </div>
      </div>
    </div>
  );
};

export default Content;
